// frontend/src/utils/apiAuth.js
//
// Authorization header for raw fetch() calls.
//
// Prefer the useApi hook, which adds this header itself and centralises 401/403
// handling. This exists for the call sites that predate it and do their own
// `res.ok` branching — every endpoint is authenticated now, so a fetch without
// the header is a 401 rather than the silent success it used to be.
//
// Reads the token from localStorage, which is where App.js keeps it, so callers
// do not have to thread googleIdToken through props that never had it.

/**
 * Merge the bearer token into a headers object.
 *
 *   fetch(url, { method: 'POST', headers: authHeaders() })
 *   fetch(url, { headers: authHeaders({ 'Content-Type': 'application/json' }) })
 *
 * Returns the extra headers unchanged when no token is stored: an
 * `Authorization: Bearer null` would be a confusing 401, and the request is
 * going to fail either way.
 */
export const authHeaders = (extra = {}) => {
    const token = localStorage.getItem('googleIdToken');
    return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
};
